const LAST_POSITION_MARKER = 'https://dj28xnb5b9x1h.cloudfront.net/images/AVL_lastPosition.svg'
const SELECTED_POSITION_MARKER = 'https://dj28xnb5b9x1h.cloudfront.net/images/AVL_selectedPosition.svg'
const SELECTED_POSITION_MARKER_RED = 'https://dj28xnb5b9x1h.cloudfront.net/images/AVL_selectedPosition-red.svg'

const SELECT_POINT_MARKER = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/selectPoint.svg'

// AGENCY 1
const MARKER_V_A_1_ON = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-01.png'
const MARKER_V_A_1_OFF = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-02.png'
const MARKER_M_A_1_ON = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-03.png'
const MARKER_M_A_1_OFF = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-04.png'
// AGENCY 2
const MARKER_V_A_2_ON = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-21.png'
const MARKER_V_A_2_OFF = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-22.png'
const MARKER_M_A_2_ON = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-23.png'
const MARKER_M_A_2_OFF = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-24.png'
// AGENCY 3
const MARKER_V_A_3_ON = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-25.png'
const MARKER_V_A_3_OFF = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-26.png'
const MARKER_M_A_3_ON = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-27.png'
const MARKER_M_A_3_OFF = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-28.png'
// AGENCY 4
const MARKER_V_A_4_ON = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-05.png'
const MARKER_V_A_4_OFF = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-06.png'
const MARKER_M_A_4_ON = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-07.png'
const MARKER_M_A_4_OFF = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-08.png'
// AGENCY 5
const MARKER_V_A_5_ON = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-13.png'
const MARKER_V_A_5_OFF = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-14.png'
const MARKER_M_A_5_ON = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-15.png'
const MARKER_M_A_5_OFF = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-16.png'
// AGENCY 6
const MARKER_V_A_6_ON = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-09.png'
const MARKER_V_A_6_OFF = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-10.png'
const MARKER_M_A_6_ON = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-11.png'
const MARKER_M_A_6_OFF = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-12.png'
// AGENCY 7
const MARKER_V_A_7_ON = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-17.png'
const MARKER_V_A_7_OFF = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-18.png'
const MARKER_M_A_7_ON = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-19.png'
const MARKER_M_A_7_OFF = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-20.png'
// AGENCY 8 (reutiliza iconos de agencia 1)
const MARKER_V_A_8_ON = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-01.png'
const MARKER_V_A_8_OFF = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-02.png'
const MARKER_M_A_8_ON = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-03.png'
const MARKER_M_A_8_OFF = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-04.png'
// AGENCY 9 (reutiliza iconos de agencia 2)
const MARKER_V_A_9_ON = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-21.png'
const MARKER_V_A_9_OFF = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-22.png'
const MARKER_M_A_9_ON = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-23.png'
const MARKER_M_A_9_OFF = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-24.png'
// AGENCY 10 (vehículos sin agencia asignada)
const MARKER_V_A_10_ON = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-29.png'
const MARKER_V_A_10_OFF = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-30.png'
const MARKER_M_A_10_ON = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-31.png'
const MARKER_M_A_10_OFF = 'https://dj28xnb5b9x1h.cloudfront.net/images/markers-avl/1-32.png'

const iconMarkers = {
  MARKER_V_A_1_ON,
  MARKER_V_A_1_OFF,
  MARKER_M_A_1_ON,
  MARKER_M_A_1_OFF,
  MARKER_V_A_2_ON,
  MARKER_V_A_2_OFF,
  MARKER_M_A_2_ON,
  MARKER_M_A_2_OFF,
  MARKER_V_A_3_ON,
  MARKER_V_A_3_OFF,
  MARKER_M_A_3_ON,
  MARKER_M_A_3_OFF,
  MARKER_V_A_4_ON,
  MARKER_V_A_4_OFF,
  MARKER_M_A_4_ON,
  MARKER_M_A_4_OFF,
  MARKER_V_A_5_ON,
  MARKER_V_A_5_OFF,
  MARKER_M_A_5_ON,
  MARKER_M_A_5_OFF,
  MARKER_V_A_6_ON,
  MARKER_V_A_6_OFF,
  MARKER_M_A_6_ON,
  MARKER_M_A_6_OFF,
  MARKER_V_A_7_ON,
  MARKER_V_A_7_OFF,
  MARKER_M_A_7_ON,
  MARKER_M_A_7_OFF,
  MARKER_V_A_8_ON,
  MARKER_V_A_8_OFF,
  MARKER_M_A_8_ON,
  MARKER_M_A_8_OFF,
  MARKER_V_A_9_ON,
  MARKER_V_A_9_OFF,
  MARKER_M_A_9_ON,
  MARKER_M_A_9_OFF,
  MARKER_V_A_10_ON,
  MARKER_V_A_10_OFF,
  MARKER_M_A_10_ON,
  MARKER_M_A_10_OFF,
  LAST_POSITION_MARKER,
  SELECTED_POSITION_MARKER,
  SELECTED_POSITION_MARKER_RED
}

export {
  SELECT_POINT_MARKER,
  iconMarkers,
  LAST_POSITION_MARKER,
  SELECTED_POSITION_MARKER,
  SELECTED_POSITION_MARKER_RED
}



// WEBPACK FOOTER //
// ./src/utils/staticsRef.js